import React from 'react';
import { Reveal } from '../ui/Reveal';
const flow = ['Elegí', 'Fabricá', 'Cotizá', 'Publicá', 'Vendé'];
export function Problem() {
  return <section className="bg-ink py-16 md:py-24" data-id="element-114" data-mp="2wfwz6lh7h7as">
      <div className="mx-auto max-w-3xl px-5 text-center md:px-8" data-id="element-115" data-mp="2rnveqc9vwa9o">
        <Reveal data-id="element-116" data-mp="2rm26isjmhhzk">
          <h2 className="font-display text-2xl font-black uppercase leading-tight text-white sm:text-3xl md:text-[2.6rem]" data-id="element-117" data-mp="2mpk5o3rey3si">
            ¿Tenés las herramientas
            <span className="block text-gold" data-id="element-118" data-mp="2hrindl1ta8i3">pero no sabés qué fabricar?</span>
          </h2>
        </Reveal>

        <Reveal delay={0.05} data-id="element-119" data-mp="2ct8trevqjfyl">
          <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-cream/70 md:text-lg" data-id="element-120" data-mp="28p9c2sypyb3n">
            Dejá de empezar cada proyecto desde cero buscando ideas, medidas,
            mecanismos y materiales por separado.
          </p>
          <p className="mx-auto mt-3 max-w-2xl text-base leading-relaxed text-cream/70 md:text-lg" data-id="element-121" data-mp="6xnx0js0jc03">
            Carpintería Plegable PRO™ reúne proyectos y recursos para ayudarte a
            transformar una idea en un mueble que puedas fabricar y sumar a tu
            catálogo.
          </p>
        </Reveal>

        <Reveal delay={0.1} data-id="element-122" data-mp="19bgbo4gpe5oq">
          <ol className="mt-12 flex flex-col items-center gap-2.5 md:flex-row md:justify-center md:gap-3" data-id="element-123" data-mp="vadn9l28kjan">
            {flow.map((step, index) => <React.Fragment key={step} data-id="element-124" data-mp="10a9r9kaxoaq7" data-mpi={index}>
                {index > 0 && <span className="font-display text-xl font-black text-gold md:text-2xl" aria-hidden="true" data-id="element-125" data-mp="1nyszjztzgnia">
                    <span className="md:hidden" data-id="element-126" data-mp="1e99dymevyfjq">↓</span>
                    <span className="hidden md:inline" data-id="element-127" data-mp="1e8q7q2yllflj">→</span>
                  </span>}
                <li className="w-full rounded-xl border border-ink-line bg-ink-soft px-5 py-4 font-display text-2xl font-black uppercase tracking-tight text-white md:w-auto md:px-4 md:text-lg lg:text-xl" data-id="element-128" data-mp="1j6rnadwtews9">
                  {step}
                </li>
              </React.Fragment>)}
          </ol>
        </Reveal>
      </div>
    </section>;
}